import { useSelector } from 'react-redux';
import { validationSchemaCampaign } from './validationSchema';
import { Form, Formik } from 'formik';
import { TextArea, TextBox } from '../../shared/controls/form';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import SelectBox from '../../shared/controls/form/selectBox';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';

const CampaignForm = ({
  formData,
  handleSubmit,
  selectedOptions,
  handleChange,
  handleChangeForm,
  errormsg,
  handleDateTime,
  templateList,
}) => {
  const owner = useSelector(getActiveOwners);
  const campaignStatus = useSelector(getGenericMasterFilteredListByKey('CampaignStatus'));
  const campaignType = useSelector(getGenericMasterFilteredListByKey('CampaignType'));

  const formatEmailToName = (email) => {
    const namePart = email.split('@')[0]; // Get before @
    return namePart
      .split('.') // Split at dots
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1)) // Capitalize each part
      .join(' '); // Join with space
  };

  const emailString = process.env.REACT_APP_FROM_ADDRESSES || '';
  const emailList = emailString.split(',').filter((email) => email.trim() !== '');

  const fromAddressOptions = emailList.map((email) => ({
    value: email,
    label: formatEmailToName(email),
  }));

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaCampaign}
    >
      <Form>
        <div className="collapse_card">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="">Campaign Information</label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Campaign Owner'}
                            name={'ownerId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.owner || '--'
                                : formData?.owner || 'Select Campaign Owner'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.ownerId}
                            handleSelect={handleChange}
                            options={owner}
                            optionKeys={['userId', 'userName']}
                            errormsg={errormsg?.ownerId}
                            nameFormatter={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Campaign Name'}
                            name={'campaignName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Campaign Name'}
                            value={formData?.campaignName}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.campaignName}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Type'}
                            name={'campaignTypeId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.campaignType || '--'
                                : formData?.campaignType || 'Select Type'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.campaignTypeId}
                            handleSelect={handleChange}
                            options={campaignType}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.campaignTypeId}
                            nameFormatter={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          {formData?.type === 'view' && (
                            <SelectBox
                              label={'Status'}
                              name={'statusId'}
                              placeholder={
                                formData?.type === 'view'
                                  ? formData?.campaignStatus || '--'
                                  : formData?.campaignStatus || 'Select Status'
                              }
                              disabled={formData?.type === 'view'}
                              selectedOptions={selectedOptions.statusId}
                              handleSelect={handleChange}
                              options={campaignStatus}
                              optionKeys={['id', 'displayName']}
                              errormsg={errormsg?.statusId}
                              // nameFormatter={true}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            isRequired={true}
                            label={'Sender'}
                            name={'senderEmail'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.senderName || '--'
                                : formData?.senderName || 'Select Sender'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.senderEmail}
                            handleSelect={handleChange}
                            options={fromAddressOptions}
                            optionKeys={['value', 'label']}
                            errormsg={errormsg?.senderEmail}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            isRequired={true}
                            label={'Campaign For'}
                            name={'campaignFor'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.campaignFor || '--'
                                : formData?.campaignFor || 'Select Campaign For'
                            }
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.campaignFor}
                            handleSelect={handleChange}
                            options={[{ id: 'lead', name: 'Lead' }]}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.campaignFor}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            isRequired={true}
                            label={'Template'}
                            name={'templateId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.templateName || '--'
                                : formData?.templateName || 'Select Template'
                            }
                            disabled={formData?.type === 'view' || !formData?.campaignFor}
                            selectedOptions={selectedOptions.templateId}
                            handleSelect={handleChange}
                            options={templateList}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.templateId}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <DateTimePicker
                            label={'Schedule At'}
                            isRequired={true}
                            value={
                              formData.scheduledDateTime
                                ? new Date(formData.scheduledDateTime)
                                : null
                            }
                            onChange={handleDateTime}
                            name="scheduledDateTime"
                            placeholder="Select Schedule date & time"
                            disabled={formData?.type === 'view'}
                            errormsg={errormsg?.scheduledDateTime}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container notesLabel">
                          <TextArea
                            label={'Description'}
                            name={'description'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                            value={formData?.description}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.description}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default CampaignForm;
